export default {
  // 锁定/解锁提货，不影响点价
  updatePickupLocked: '/ygsjzs/yxPriceOrder/updatePickupLocked',
  // 审批锁价订单
  approvalYxPriceOrder: '/ygsjzs/yxPriceOrder/approvalYxPriceOrder',

  // 删除锁价订单
  deleteYxPriceOrder: '/ygsjzs/yxPriceOrder/deleteYxPriceOrder',

  // 新增锁价订单
  insertYxPriceOrder: '/ygsjzs/yxPriceOrder/insertYxPriceOrder',

  // 修改锁价订单
  updateYxPriceOrder: '/ygsjzs/yxPriceOrder/updateYxPriceOrder',

  // 查询锁价订单详情
  selectYxPriceOrderByOrderId: '/ygsjzs/yxPriceOrder/selectYxPriceOrderByOrderId',
  // 分页查询锁价订单列表
  selectYxPriceOrderByPage: '/ygsjzs/yxPriceOrder/selectYxPriceOrderByPage',
  // 导出
  exportYxPriceOrder: '/ygsjzs/yxPriceOrder/exportYxPriceOrder',
  // 点价时间配置
  updateYxStatus: '/ygsjzs/YxGdx/updateYxStatus',
  selectYxStatus: '/ygsjzs/YxGdx/selectYxStatus',
  // 查看订单剩余可提货数量
  selectOrderNum: '/ygsjzs/yxPickupOrder/selectOrderNum',

  // 提货日期、
  updateYxPriceOrderDate: '/ygsjzs/yxPriceOrder/updateYxPriceOrderDate',
  // 释放
  endYxPriceOrderDate: '/ygsjzs/yxPriceOrder/endYxPriceOrderDate',
  // 退回订单
  backYxPriceOrder: '/ygsjzs/yxPriceOrder/backYxPriceOrder',

  // 修改点击数量
  updateYxPriceNum: '/ygsjzs/yxPriceNum/updateYxPriceNum',
  // 修改单日提货数量
  updateYxPriceOrderNum: '/ygsjzs/yxPriceOrder/updateYxPriceOrderNum',
  // 获取点价数量详情
  selectYxPriceNumByNumId: '/ygsjzs/yxPriceNum/selectYxPriceNumByNumId',
  // 货权转移的接口
  insertYxPriceOrderRes: '/ygsjzs/yxPriceOrderResRes/insertYxPriceOrderRes',
  approvalYxPriceOrderRes: '/ygsjzs/yxPriceOrderResRes/approvalYxPriceOrderRes',
  approvalYxPriceOrderHg: '/ygsjzs/yxPriceOrderResRes/approvalYxPriceOrderHg',
  txHgPdf: '/ygsjzs/yxPriceOrderResRes/txHgPdf'
}
